import Main from "../components/views/main/Main.vue";
// import Dashboard from '../components/views/dashboard/Dashboard.vue'
// import profileRoutes from './profile.route'
import roles from './roles.route'
import devicesRoutes from './devices.route'
import userRoutes from './users.route'
import regionRoutes from './region.route'
import vehicleRoutes from './vehicles.route'
import driverRoutes from './driver.route'
import siteRoutes from './sites.route'
import tripRoutes from './trips.route'
import tripRouteRoutes from './tripRoute.route'
import salesdataRoutes from './salesdata.route'
import reportgenerationRoutes from './reportgeneration.route'
import schedulereportRoutes from './schedulereport.route'
import dashboardRoutes from './dashboard.route'
import VehicleStatusRoutes from './VehicleStatus.route'
import technicianRoutes from './technician.route'
import registerRoutes from './register.route'
import profileRoutes from './profile.route'
import operatorreportRoutes from './operatorreport.route'
import permissionRoutes from './permissions.route'
import usersRoutes from '../routes/users.route'
import cityRoutes from '../routes/city.route'
import transportRoute from '../routes/transport.route'
import segregationRoute from '../routes/segregation.route'
import dumpyardRoute from '../routes/dumpyard.route'
import wasteCollectionAreaRoute from '../routes/wasteCollectionArea.route'
import vendorRoute from '../routes/vendor.route'
import wastetypeRoute from '../routes/wastetype.route'
import helperAndDriverRoute from '../routes/helperAndDriver.route'
import secondaryTripRoute from '../routes/secondaryTrip.route'
import segregationPlantTripRoute from '../routes/segregationPlantTrip.route'
import primaryTripRoute from '../routes/primaryTrip.route'
import transportPointTripRoute from '../routes/transportPointTrip.route'
// import dailyWagesRoute from '../routes/dailyWages.route'
import vehicleRoute from '../routes/vehicle.route'
import fuelexpensesRoute from '../routes/fuelexpenses.route'
import wasterecycleRoute from '../routes/wasterecycle.route'
import vehicleMaintenance from '../routes/vehicleMaintenance.route'
import misCellaneous from "../routes/miscellaneous.route";
import dailyWages from "../routes/dailywages.route";
import surveysRoute from '../routes/surveys.route';
import housesRoute from '../routes/houses.route';
import wastesegregationRoute from '../routes/wastesegregation.route';
import monitoringRoute from '../routes/monitoring.route';
import reportsRoute from '../routes/reports.route';


// import auditLogRoutes from './audit-logs.route'

const routes = [
  {
    path: "/",
    component: Main,
    children: [
      // {
      // 	path: 'dashboard',
      // 	alias: '',
      // 	component: Dashboard,
      // 	name: 'Dashboard',
      // 	meta: {
      // 		description: 'Overview of app',
      // 		title: 'Dashboard',
      // 		requiresAuth: true
      // 	}
      // },
      // {
      // 	path: 'profile',
      // 	component: Profile,
      // 	name: 'Profile',
      // 	meta: {
      // 		description: 'Profile details',
      // 		title: 'Profile',
      // 		requiresAuth: true
      // 	}
      // },
      ...siteRoutes,
      ...driverRoutes,
      ...vehicleRoutes,
      ...devicesRoutes,
      ...regionRoutes,
      ...userRoutes,
      ...roles,
      ...tripRoutes,
      ...tripRouteRoutes,
      ...salesdataRoutes,
      ...reportgenerationRoutes,
      ...schedulereportRoutes,
      ...dashboardRoutes,
      ...VehicleStatusRoutes,
      ...technicianRoutes,
      ...registerRoutes,
      ...profileRoutes,
      ...operatorreportRoutes,
      ...permissionRoutes,
      ...usersRoutes,
      ...cityRoutes,
      ...transportRoute,
      ...segregationRoute,
      ...dumpyardRoute,
      ...wasteCollectionAreaRoute,
      ...vendorRoute,
      ...wastetypeRoute,
      ...helperAndDriverRoute,
      ...secondaryTripRoute,
      ...segregationPlantTripRoute,
      ...primaryTripRoute,
      ...transportPointTripRoute,
      ...vehicleRoute,
      ...fuelexpensesRoute,
      ...wasterecycleRoute,
      ...vehicleMaintenance,
      ...misCellaneous,
      ...dailyWages,
      ...surveysRoute,
      ...housesRoute,
      ...wastesegregationRoute,
      ...monitoringRoute,
      ...reportsRoute
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/main.route.js